import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { iobjTransportista } from '../models/iTransportistas.model'
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SituacionService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    /***Servicios situacion******/

    buscarSituacion(tipdoc: number, situacion: string): Observable<any> {
        this.apiService.setUrlPathApi('situacion/buscar?');
        return this.apiService.execGetQueryJson(`tipdoc=${tipdoc}&situaciones=${situacion }`);
    }



} 